import React from 'react';
import './desktopCart.css';

const PriceView = (props) => {
  const renderHTMLContent = (item) => (
    <>
    {item.strikedPrice && item.strikedPrice !== 0.00 ? (
            <>
              {item.strikedPrice !== item?.displayPrice && (
                <span>
                  <span className="actualPriceStrikeThrough">{item?.strikedPrice}</span>&nbsp;
                </span>
              )}
              {item?.displayPrice}
            </>
          ) : (
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <p className="content_container">{item.displayPrice}</p>
            </div>
          )}
          </>
     );
  return (
     renderHTMLContent(props.item)
  );
};

export default PriceView;
